// extracted by mini-css-extract-plugin
export default {"academyCreateLink":"styles_academyCreateLink__HU03z","academyCreateButton":"styles_academyCreateButton__12WlN","fadeIn":"styles_fadeIn__RA3BW"};